import { Edge, EdgeProps, EdgeTypes } from '@xyflow/react';
import InsertEdgeSmooth from '../components/Edges/InsertEdgeSmooth';
import InsertEdge from '../components/Edges/InsertEdge';
export interface EdgeMetadata {
  createdBy: string;
  createdTimeStamp: string;
  updatedBy: string;
  updatedTimeStamp: string;
}

export interface InsertEdgeProps
  extends Omit<EdgeProps, 'sourcePosition' | 'targetPosition'> {
  id: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  sourcePosition: string;
  targetPosition: string;
  markerEnd: string;
}

export interface AppEdge extends Edge {
}

export const edgeTypes = {
  insertSmooth: InsertEdgeSmooth,
  insert: InsertEdge,
  // Add your custom edge types here!
} satisfies EdgeTypes;

export type LocalEdgeTypes = 'insertSmooth' | 'insert';

export interface LocalEdge extends Edge {
  id: string;
  source: string;
  target: string;
  type: LocalEdgeTypes;
}
